import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  signal,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AppRoutes } from '../../models/route-model';
import { MatIconModule } from '@angular/material/icon';
import { UserLoginInDto } from '../../../submodules/silverlight-common/lib/ts/src/dtos/user.login.dto';
import { AuthService } from '../../services/auth.service';
import { of } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { HeaderPanelComponent } from '../header-panel/header-panel.component';
import { LogHandler } from '../../helpers/log.handler';
import { logEventEnum } from '../../../submodules/silverlight-common/lib/ts/src/common-enums/log.event.enums';
import { ActViewerService } from '../../services/act-viewer.service';
import { SharedService } from '../../services/shared.service';
import UIConstants from '../../../app-constants/ui-constants';
/**
 * Component for displaying the login page.
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    HeaderPanelComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AuthService],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({});

  constructor(
    private router: Router,
    private authService: AuthService,
    private actViewerService: ActViewerService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef,
  ) {
    this.router = router;

    if (this.sharedService.getIsLoginSessionActive) {
      console.log(
        'User already logged info' +
        JSON.stringify(this.sharedService.getCurrentAccessToken)
      );
      this.router.navigate([AppRoutes.route_home]);
    }
  }
  hide = signal(true);
  errorMessage = '';
  loginConstants = UIConstants.Login
  toggleViewPassword = (e:Event) => {
e.preventDefault()
    this.hide.set(!this.hide());
  };

  ngOnInit() {
    this.loginForm = new FormGroup({
      ctrlUsernameOremail: new FormControl('', [Validators.required]),
      ctrlPass: new FormControl('', Validators.required),
    });
  }

  async onSubmit(e:Event): Promise<void> {
    e.preventDefault()

    const coords = await this.getCoordinates();
    const userNameorEmailValue = this.loginForm.get(this.loginConstants.USERNAME_OR_EMAIL_CONTROL)?.value
    const loginData: UserLoginInDto = {
      usernameOremail:userNameorEmailValue,
      pass: this.loginForm.get('ctrlPass')?.value,
      geoLocation: `${String(coords.latitude)},${String(coords.longitude)}`,
    };

    this.authService.login(loginData).subscribe({
      next: (data) => {
        this.router.navigate([AppRoutes.route_home]);
        const logger = new LogHandler(this.sharedService, this.actViewerService)
        logger.captureLogData(`user logged in PLC APP`, logEventEnum.INFO);
      },
      error: (error) => {
        console.error('Login failed', error);
        // Handle login error (e.g., show error message)
        this.loginForm.setErrors({ loginFailed: true });
        return of('');
      },
    });
  }

  getCoordinates(): Promise<{ latitude: number; longitude: number }> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          (error) => {
            // Handle geolocation error
            resolve({ latitude: 0, longitude: 0 });
          }
        );
      } else {
        // Geolocation not supported
        resolve({ latitude: 0, longitude: 0 });
      }
    });
  }
}
